var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUntested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#9ca3af"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 17,
    textAnchor: "middle",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#fff"
  }, "?")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUntested);
export default __webpack_public_path__ + "static/media/icon-untested.73e5a9fd100c176851e27c6d9d7c2f9b.svg";
export { ForwardRef as ReactComponent };